import React from "react";
import Insights from "../Components/Insights/Index";
import DataInjection from "../Components/Data_Injection/Index";
import ViewPastUploads from "../Components/ViewPast_Uploads/Index";
import AuditUniverse from "../Components/Data_Injection/Audit-Universe/Index";
import Dashboard from "../pages/Dashboard";
import EDA from "../Components/Insights/EDA";

const routes = [
  // {
  //   path: "/",
  //   label: "Dashboard",
  //   element: <Dashboard />,
  // },
  {
    path: "/Insights",
    label: "Insights",
    children: [
      {
        path: "EDA",
        label: "EDA",
        element: <EDA />,
      },
    ],
  },
  {
    path: "/data-injection",
    label: "Data Injection",
    children: [
      // {
      //   index: true,
      //   label: "Data Injection",
      //   element: <DataInjection />,
      // },
      {
        path: "audit-universe",
        label: "Audit Universe",
        element: <AuditUniverse />,
      },
    ],
  },
  {
    path: "/view-past-uploads",
    label: "View Past Uploads",
    element: <ViewPastUploads />,
  },
];

export default routes;
